import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import { useCallback, useEffect } from "react";
import { ChecklistServicoLiberacao } from "../../../../domain/models/checklist_servico_liberacao";
import { ChecklistServicoLiberacaoCopiaForm, defaultChecklistServicoLiberacaoCopiaForm, ChecklistServicoLiberacaoCopiaSchema } from "../../../schemas/ChecklistServicoLiberacao_lista/checklistServicoLiberacaoCopia";

import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import PrimaryButton from "../../../../../../common/components/primary_button";

type props = {
  open: boolean,
  saving: boolean,
  selectedChecklistServicoLiberacao?: ChecklistServicoLiberacao | null,
  onClose: () => void,
  onSubmit: (form: ChecklistServicoLiberacaoCopiaForm) => void,
}

export const CopiaChecklistServicoLiberacaoModal = ({
  open,
  saving,
  selectedChecklistServicoLiberacao,
  onClose,
  onSubmit,
}: props) => {
  const hookFormCopia = useForm<ChecklistServicoLiberacaoCopiaForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    defaultValues: defaultChecklistServicoLiberacaoCopiaForm,
    resolver: zodResolver(ChecklistServicoLiberacaoCopiaSchema),
  });

  useEffect(() => {
    if (open && selectedChecklistServicoLiberacao) {
      hookFormCopia.setValue('idChecklistServico', selectedChecklistServicoLiberacao.idChecklistServico);
      hookFormCopia.setValue('ordem', selectedChecklistServicoLiberacao.ordem ?? "");
      hookFormCopia.setValue('descricao', selectedChecklistServicoLiberacao.descricao ?? "");
    }

  }, [
    selectedChecklistServicoLiberacao,
    open,
    hookFormCopia
  ]);

  const handleSubmit = useCallback((form: ChecklistServicoLiberacaoCopiaForm) => {
    if (!saving) {
      onSubmit(form);
      hookFormCopia.reset();
    }
  }, [
    saving,
    onSubmit,
    hookFormCopia
  ]);

  const handleClose = useCallback(() => {
    if (!saving) onClose();
  }, [saving, onClose]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      slotProps={{
        paper: {
          component: 'form',
          sx: { width: 400 },
          onSubmit: hookFormCopia.handleSubmit(handleSubmit)
        }

      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "45rem",
          },
        },
      }}>

      <DialogTitle>
        Copiar Checklist de Liberação
      </DialogTitle>

      <DialogContent>
        <ModalLoading loading={saving}  >
          <FormContainer title={"Informações"} arrangement="fullRow">
            <>
              <DefaultFormInput
                name='ordem'
                label='Ordem'
                readOnly={false}
                required={true}
                reactHookForm={hookFormCopia}

              />

              <DefaultFormInput
                name={'descricao'}
                label="Descrição"
                readOnly={false}
                required={true}
                multiline={true}
                rows={5}
                reactHookForm={hookFormCopia}
              />
            </>
          </FormContainer>

        </ModalLoading>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex px-4 pb-4 gap-4">

          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              {saving ? (
                <PrimaryButton
                  buttonColor="primary-green">
                  Salvando...
                </PrimaryButton>
              ) : (
                <PrimaryButton
                  type="submit"
                  buttonColor="primary-green">
                  Salvar
                </PrimaryButton>
              )}
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}